import React, { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/DataViews";
import { Card } from "@/components/ui/card";
import { Activity } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit-logs?limit=300").then((r) => setLogs(r.data)).finally(() => setLoading(false)); }, []);

  const actionColor = (a) => ({
    create: "text-blue-700 dark:text-blue-400",
    update: "text-amber-700 dark:text-amber-400",
    delete: "text-red-700 dark:text-red-400",
    approve: "text-emerald-700 dark:text-emerald-400",
    reject: "text-red-700 dark:text-red-400",
    submit: "text-purple-700 dark:text-purple-400",
    login: "text-zinc-600 dark:text-zinc-400",
    paid: "text-emerald-700 font-bold",
    verify: "text-emerald-700 dark:text-emerald-400",
  }[a] || "text-foreground");

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Every transaction. Every user. Every keystroke — timestamped and immutable." />
      <Card className="p-0 overflow-hidden">
        <div className="max-h-[calc(100vh-16rem)] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 sticky top-0">
              <tr className="text-left text-[10px] uppercase tracking-widest text-muted-foreground">
                <th className="px-4 py-3">Timestamp</th>
                <th className="px-4 py-3">User</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Entity</th>
                <th className="px-4 py-3">Reference</th>
                <th className="px-4 py-3">IP</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="text-center py-16 text-muted-foreground">Loading…</td></tr>}
              {!loading && logs.length === 0 && <tr><td colSpan={6} className="text-center py-16 text-muted-foreground">No audit entries yet.</td></tr>}
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-border">
                  <td className="px-4 py-2 text-xs font-mono">{fmtDateTime(l.created_at)}</td>
                  <td className="px-4 py-2">{l.user_name || "-"}</td>
                  <td className={`px-4 py-2 font-semibold capitalize ${actionColor(l.action)}`}>{l.action}</td>
                  <td className="px-4 py-2 text-xs">{l.entity_type}</td>
                  <td className="px-4 py-2 text-xs font-mono">{l.entity_ref || l.entity_id?.slice(0, 8)}</td>
                  <td className="px-4 py-2 text-xs text-muted-foreground">{l.ip_address}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
